import { Send } from "lucide-react";

/**
 * Composer row pinned to the bottom of the dock.
 */
export default function ComposerInput({ input, onChange, onSend, busy }) {
  return (
    <div
      className="p-3 border-t border-slate-200 flex items-center gap-2"
      style={{
        paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))",
        paddingRight: "14rem",
      }}
    >
      <input
        data-testid="ai-input"
        value={input}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSend()}
        placeholder="Ask NEXUS anything…"
        className="nexus-input"
      />
      <button
        data-testid="ai-send"
        onClick={onSend}
        disabled={busy}
        className="nexus-btn-primary disabled:opacity-50 flex items-center gap-2 !py-2.5 !px-4"
        aria-label="Send"
      >
        <Send size={16} />
      </button>
    </div>
  );
}
